export const backendErrorCodes = [
  'MISSING_DATASOURCE_AVQ',
  'MISSING_DATASOURCE_TUN',
  'MISSING_DATASOURCE_PMS',
  'MISSING_DATASOURCE_ASM',
  'MISSING_DATASOURCE_LDAP',
  'MISSING_DATASOURCE_CALYPSO',
  'AUTH_ERROR_DATASOURCE_AVQ',
  'AUTH_ERROR_DATASOURCE_TUN',
  'AUTH_ERROR_DATASOURCE_PMS',
  'AUTH_ERROR_DATASOURCE_ASM',
  'SSL_ERROR_PMS',
  'BACKEND_ERROR_AVQ',
  'BACKEND_ERROR_TUN',
  'BACKEND_ERROR_PMS',
  'BACKEND_ERROR_ASM',
  'MISSING_DATA_IN_AVQ',
  'UNKNOWN_VALUE_RETURNED',
  'DOCUMENT_ENTITY_MISMATCH',
];

export type BackendErrorCode = (typeof backendErrorCodes)[number];

export const frontendFetchErrorCodes = [
  // errors codes returned by the base query (fetchBaseQuery)
  'FETCH_ERROR',
  'PARSING_ERROR',
  'TIMEOUT_ERROR',
  'CUSTOM_ERROR',
] as const;

export type FrontendFetchErrorCode = (typeof frontendFetchErrorCodes)[number];
